module.exports = __webpack_public_path__ + "static/media/arrow.6a5c4c31.svg";